/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationStatus } from './HomeHealthCertificationStatus';
import {
    HomeHealthCertificationStatusFromJSON,
    HomeHealthCertificationStatusFromJSONTyped,
    HomeHealthCertificationStatusToJSON,
    HomeHealthCertificationStatusToJSONTyped,
} from './HomeHealthCertificationStatus';
import type { HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitioner } from './HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitioner';
import {
    HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitionerFromJSON,
    HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitionerFromJSONTyped,
    HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitionerToJSON,
    HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitionerToJSONTyped,
} from './HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitioner';
import type { HomeHealthCertificationAttestation } from './HomeHealthCertificationAttestation';
import {
    HomeHealthCertificationAttestationFromJSON,
    HomeHealthCertificationAttestationFromJSONTyped,
    HomeHealthCertificationAttestationToJSON,
    HomeHealthCertificationAttestationToJSONTyped,
} from './HomeHealthCertificationAttestation';
import type { HomeHealthCertificationReviewReason } from './HomeHealthCertificationReviewReason';
import {
    HomeHealthCertificationReviewReasonFromJSON,
    HomeHealthCertificationReviewReasonFromJSONTyped,
    HomeHealthCertificationReviewReasonToJSON,
    HomeHealthCertificationReviewReasonToJSONTyped,
} from './HomeHealthCertificationReviewReason';

/**
 * 
 * @export
 * @interface HomeHealthCertificationCriteriaUnderPractitionerCare
 */
export interface HomeHealthCertificationCriteriaUnderPractitionerCare {
    /**
     * 
     * @type {HomeHealthCertificationStatus}
     * @memberof HomeHealthCertificationCriteriaUnderPractitionerCare
     */
    status: HomeHealthCertificationStatus;
    /**
     * 
     * @type {Array<HomeHealthCertificationReviewReason>}
     * @memberof HomeHealthCertificationCriteriaUnderPractitionerCare
     */
    review_reasons: Array<HomeHealthCertificationReviewReason>;
    /**
     * 
     * @type {HomeHealthCertificationAttestation}
     * @memberof HomeHealthCertificationCriteriaUnderPractitionerCare
     */
    attestation: HomeHealthCertificationAttestation;
    /**
     * 
     * @type {HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitioner}
     * @memberof HomeHealthCertificationCriteriaUnderPractitionerCare
     */
    following_practitioner: HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitioner;
}



/**
 * Check if a given object implements the HomeHealthCertificationCriteriaUnderPractitionerCare interface.
 */
export function instanceOfHomeHealthCertificationCriteriaUnderPractitionerCare(value: object): value is HomeHealthCertificationCriteriaUnderPractitionerCare {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('review_reasons' in value) || value['review_reasons'] === undefined) return false;
    if (!('attestation' in value) || value['attestation'] === undefined) return false;
    if (!('following_practitioner' in value) || value['following_practitioner'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationCriteriaUnderPractitionerCareFromJSON(json: any): HomeHealthCertificationCriteriaUnderPractitionerCare {
    return HomeHealthCertificationCriteriaUnderPractitionerCareFromJSONTyped(json, false);
}

export function HomeHealthCertificationCriteriaUnderPractitionerCareFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationCriteriaUnderPractitionerCare {
    if (json == null) {
        return json;
    }
    return {
        
        'status': HomeHealthCertificationStatusFromJSON(json['status']),
        'review_reasons': ((json['review_reasons'] as Array<any>).map(HomeHealthCertificationReviewReasonFromJSON)),
        'attestation': HomeHealthCertificationAttestationFromJSON(json['attestation']),
        'following_practitioner': HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitionerFromJSON(json['following_practitioner']),
    };
}

export function HomeHealthCertificationCriteriaUnderPractitionerCareToJSON(json: any): HomeHealthCertificationCriteriaUnderPractitionerCare {
    return HomeHealthCertificationCriteriaUnderPractitionerCareToJSONTyped(json, false);
}

export function HomeHealthCertificationCriteriaUnderPractitionerCareToJSONTyped(value?: HomeHealthCertificationCriteriaUnderPractitionerCare | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': HomeHealthCertificationStatusToJSON(value['status']),
        'review_reasons': ((value['review_reasons'] as Array<any>).map(HomeHealthCertificationReviewReasonToJSON)),
        'attestation': HomeHealthCertificationAttestationToJSON(value['attestation']),
        'following_practitioner': HomeHealthCertificationCriteriaUnderPractitionerCareFollowingPractitionerToJSON(value['following_practitioner']),
    };
}

